/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import useTranslate from '../../../../app/hooks/useTranslate'
import { MenuComponent } from '../../../assets/ts/components'
import './header-user-menu.scss'

const getInitials = (value?: string) => {
  if (!value) return 'KP'
  const cleaned = value.trim()
  if (!cleaned) return 'KP'
  if (cleaned.includes('@')) {
    return cleaned.slice(0, 2).toUpperCase()
  }
  const parts = cleaned.split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
}

const closeUserMenu = () => {
  MenuComponent.hideDropdowns(undefined)
}

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()
  const t = useTranslate()

  const displayName = currentUser?.firstName || currentUser?.email || 'Admin'
  const email = currentUser?.email || ''
  const initials = useMemo(
    () => getInitials(currentUser?.firstName || currentUser?.email),
    [currentUser?.firstName, currentUser?.email]
  )

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg fw-bold py-0 fs-5 w-300px kp-user-menu'
      data-kt-menu='true'
      data-popper-placement='bottom-start'
    >
      <div className='kp-user-menu-header'>
        <div className='kp-user-menu-avatar' aria-hidden='true'>
          {initials}
        </div>
        <div className='kp-user-menu-meta'>
          <span className='kp-user-menu-kicker'>Signed in</span>
          <span className='kp-user-menu-name' title={displayName}>
            {displayName}
          </span>
          {email && (
            <span className='kp-user-menu-email' title={email}>
              {email}
            </span>
          )}
        </div>
      </div>

      <div className='kp-user-menu-actions'>
        <Link
          to='/users/settings'
          className='kp-user-menu-link'
          onClick={closeUserMenu}
        >
          <i className='bi bi-gear'></i>
          <span>Settings</span>
        </Link>
        <button
          type='button'
          className='kp-user-menu-link is-danger'
          onClick={() => {
            closeUserMenu()
            logout()
          }}
        >
          <i className='bi bi-box-arrow-right'></i>
          <span>{t('SIGN_OUT')}</span>
        </button>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
